import gql from 'graphql-tag'

export const GET_SORTED_INSTRUCTORS_BY_PROGRAM = gql`
  query GetSortedInstructorsByProgram($sortedInstructorsByProgram: GetSortedInstructorsByProgramInput!) {
    getSortedInstructorsByProgram(sortedInstructorsByProgram: $sortedInstructorsByProgram) {
      instructorInfo {
        Ranking
        Name
        InstructorId
      }
    }
  }
`
